const DOCUMENT = 'ADD_SESSION_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  TOUCH_PROPERTY: DOCUMENT + 'TOUCH_PROPERTY',
  CHANGE_FREQUENCY: DOCUMENT + 'CHANGE_FREQUENCY',
  TOGGLE_RECURRING_SELECTED: DOCUMENT + 'TOGGLE_RECURRING_SELECTED',
  TOGGLE_EXCLUDE_WEEKENDS_SELECTED: DOCUMENT + 'TOGGLE_EXCLUDE_WEEKENDS_SELECTED',
  TOGGLE_INCLUDE_SAME_POSITION_SELECTED: DOCUMENT + 'TOGGLE_INCLUDE_SAME_POSITION_SELECTED',
  LOAD_MANAGERS_REQUEST: DOCUMENT + 'LOAD_MANAGERS_REQUEST',
  LOAD_MANAGERS_SUCCESS: DOCUMENT + 'LOAD_MANAGERS_SUCCESS',
  LOAD_RECENT_LOCATIONS_REQUEST: DOCUMENT + 'LOAD_RECENT_LOCATIONS_REQUEST',
  LOAD_RECENT_LOCATIONS_SUCCESS: DOCUMENT + 'LOAD_RECENT_LOCATIONS_SUCCESS',
  CREATE_ORIENTATION_REQUEST: DOCUMENT + 'CREATE_ORIENTATION_REQUEST',
  CREATE_ORIENTATION_SUCCESS: DOCUMENT + 'CREATE_ORIENTATION_SUCCESS',
  CREATE_ORIENTATION_FAILED: DOCUMENT + 'CREATE_ORIENTATION_FAILED',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  touchProperty: data => ({
    type: actions.TOUCH_PROPERTY,
    payload: data,
  }),

  changeFrequency: data => ({
    type: actions.CHANGE_FREQUENCY,
    payload: data,
  }),

  toggleRecurringSelected: data => ({
    type: actions.TOGGLE_RECURRING_SELECTED,
    payload: data,
  }),

  toggleExcludeWeekendsSelected: data => ({
    type: actions.TOGGLE_EXCLUDE_WEEKENDS_SELECTED,
    payload: data,
  }),

  toggleIncludeSamePositionsSelected: data => ({
    type: actions.TOGGLE_INCLUDE_SAME_POSITION_SELECTED,
    payload: data,
  }),

  loadManagersRequest: () => {
    return {
      type: actions.LOAD_MANAGERS_REQUEST,
    };
  },

  loadManagersSuccess: data => ({
    type: actions.LOAD_MANAGERS_SUCCESS,
    payload: data,
  }),

  loadRecentLocationsRequest: () => {
    return {
      type: actions.LOAD_RECENT_LOCATIONS_REQUEST,
    };
  },

  loadRecentLocationsSuccess: data => ({
    type: actions.LOAD_RECENT_LOCATIONS_SUCCESS,
    payload: data,
  }),

  createOrientationRequest: data => ({
    type: actions.CREATE_ORIENTATION_REQUEST,
    payload: data,
  }),

  createOrientationSuccess: data => ({
    type: actions.CREATE_ORIENTATION_SUCCESS,
    payload: data,
  }),

  createOrientationFailed: data => ({
    type: actions.CREATE_ORIENTATION_FAILED,
    payload: data,
  }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
